import React, { useEffect, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import SCUIDraggableCustomTable from '../../../atomic/molecules/SCUIDraggableCustomDataGrid/SCUIDraggableCustomDataGrid';
import { PostCheckoutQuery } from '../../../services/query';
import { IconButton, LinearProgress, Menu, MenuItem, Switch, Box } from '@mui/material';
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTranslation } from 'react-i18next';
import { PostCheckoutCommand } from '../../../services/command';
import Swal from 'sweetalert2';
import CopyToClipboardButton from '../../../atomic/atoms/SCUICopyToClipboardButton/SCUICopyToClipboardButton';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { DCDG } from '../digitalCard.classes';

const DragDropTable = ({ setSelectedDigitalCard, onDrawerOpen, refresh }: any) => {
    const { t } = useTranslation();
    const [dragdropLoading, setDragdropLoading] = useState(false);
    const [digitalCardDatas, setDigitalCardDatas] = useState([]);

    useEffect(() => {
        GetDigitalCard();
    }, [refresh]);

    const handleDeleteDigitalCard = async (id: any) => {
        const result = await Swal.fire({
            title: t('general.sureText'),
            text: t('general.noReturn'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        });

        if (!result.isConfirmed) {
            return;
        }

        const req = { DigitalCardTemplateIds: [id] };
        const res = await PostCheckoutCommand.DeleteDigitalCardTemplates(req);
        if (res) {
            await Swal.fire(t('general.deleted'), t('digitalGiftCard.digitalGiftCardDeleted'), 'success');
            GetDigitalCard();
        }
    };

    const columns = [
        {
            field: 'icon',
            headerName: '',
            width: 50,
            align: 'center',
            headerAlign: 'center',
            flex: 1,
        },
        {
            field: 'displayOrder',
            headerName: t('general.queueNumber'),
            width: 70,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'imageUrl',
            align: 'center',
            headerAlign: 'center',
            headerName: t('digitalGiftCard.digitalGiftCardDesign'),
            width: 200,
            flex: 1,
            renderCell: (params: any) => (
                <div>
                    {params.row.imageUrl}
                    <CopyToClipboardButton textToCopy={params.row.imageUrl} />
                    <a
                        className={DCDG.linkOpenImage}
                        href={params.row.imageUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ marginLeft: '10px', color: '#03a9f4' }}
                    >
                        <OpenInNewIcon />
                    </a>
                </div>
            ),
        },
        {
            field: 'title',
            align: 'center',
            headerAlign: 'center',
            headerName: t('digitalGiftCard.digitalGiftCardName'),
            width: 200,
            flex: 1,
        },
        {
            field: 'templateStatus',
            align: 'center',
            headerAlign: 'center',
            headerName: t('digitalGiftCard.activeStatus'),
            width: 200,
            flex: 1,
            renderCell: (params: any) => <Switch checked={params.row.templateStatus === 1} disabled />,
        },
        {
            field: 'deneme ',
            headerName: ' ',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            renderCell: (params: any) => {
                const handleClick = (popupState: any, tur: string) => {
                    popupState.close();
                    switch (tur) {
                        case 'gotoDetail': {
                            setSelectedDigitalCard(params.row);
                            onDrawerOpen();
                            break;
                        }
                        case 'delete': {
                            handleDeleteDigitalCard(params.row.id);
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                };
                return (
                    <PopupState variant="popover" popupId="demo-popup-menu">
                        {(popupState: any) => (
                            <React.Fragment>
                                <IconButton className={DCDG.inputIconRowMenu} {...bindTrigger(popupState)}>
                                    {' '}
                                    <MoreVertIcon className="svg_icons" />{' '}
                                </IconButton>
                                <Menu {...bindMenu(popupState)}>
                                    <MenuItem onClick={() => handleClick(popupState, 'gotoDetail')}>
                                        {t('general.edit')}{' '}
                                    </MenuItem>
                                    <MenuItem onClick={() => handleClick(popupState, 'delete')}>
                                        {t('general.delete')}{' '}
                                    </MenuItem>
                                </Menu>
                            </React.Fragment>
                        )}
                    </PopupState>
                );
            },
        },
    ];
    const GetDigitalCard = () => {
        PostCheckoutQuery.GetDigitalCardTemplates()
            .then((res: any) => {
                if (res) {
                    let parseData = res.map((item: any) => {
                        return {
                            id: item.digitalCardTemplateId,
                            description: item.description || '-',
                            displayOrder: item.displayOrder,
                            iconUrl: item.iconUrl,
                            imageUrl: item.imageUrl || '-',
                            // isDefault: item.isDefault,
                            templateStatus: item.templateStatus,
                            title: item.title || '-',
                            modifiedBy: item.modifiedBy || '-',
                            modifiedDate: item.modifiedDate,
                            createdBy: item.createdBy || '-',
                            createdDate: item.createdDate,
                        };
                    });
                    setDigitalCardDatas(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    const handleSortDigitalCard = (rows: any) => {
        setDragdropLoading(true);
        let rowIds = rows.map((item: any) => item.id);
        let req = { Ids: rowIds };
        PostCheckoutCommand.UpdateDigitalCardDisplayOrder(req)
            .then((res: any) => {
                if (!res.isSucceed) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: t('general.anErrorOccured'),
                    });
                }
                GetDigitalCard();
            })
            .finally(() => {
                setDragdropLoading(false);
            });
    };

    if (dragdropLoading) {
        return <LinearProgress className={DCDG.loadingLinear} />;
    }
    return (
        <Box className={DCDG.root}>
            <DndProvider backend={HTML5Backend}>
                <Box className={DCDG.tableWrap}>
                    <SCUIDraggableCustomTable
                        columns={columns}
                        rows={digitalCardDatas}
                        onTableSortUpdate={(rows: any) => {
                            handleSortDigitalCard(rows);
                        }}
                    />
                </Box>
            </DndProvider>
        </Box>
    );
};

export default DragDropTable;
